module.exports = __webpack_public_path__ + "img/download-3-panel-2-INT.af15a1a9.png";